import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function downloadElementAsPdf(element, fileName) {
  if (!element) {
    return;
  }

  const pageElements = element.querySelectorAll('[data-pdf-page="true"]');
  const renderTargets = pageElements.length ? Array.from(pageElements) : [element];
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfPageHeight = pdf.internal.pageSize.getHeight();

  for (let index = 0; index < renderTargets.length; index += 1) {
    const canvas = await html2canvas(renderTargets[index], {
      scale: 1.5,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.98);
    const availableWidth = pdfWidth - 10;
    const availableHeight = pdfPageHeight - 10;
    const scale = Math.min(
      availableWidth / canvas.width,
      availableHeight / canvas.height,
    );
    const renderWidth = canvas.width * scale;
    const renderHeight = canvas.height * scale;
    const positionX = (pdfWidth - renderWidth) / 2;
    const positionY = (pdfPageHeight - renderHeight) / 2;

    if (index > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      imgData,
      "JPEG",
      positionX,
      positionY,
      renderWidth,
      renderHeight,
    );
  }

  pdf.save(fileName);
}